import React,  { useRef } from 'react'
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import './MediaControlButton.css'
import { styled } from "@mui/material/styles";
import Loader from "../../../../components/Loader/Loader";


/** 
    * A button that can be used to control media devices.
    * @param {function} onClick - The function to call when the button is clicked.
    * @param {function} onChevronClick - The function to call when the chevron is clicked. (Passes the event.currentTarget object)
    * @param {boolean} hasChevron - If true, the button will have a chevron.
    * @param {boolean} loading - If true, the button will show a loading indicator.
    * @param {boolean} active - If true, the button will be active.
    * @param {string} activeIcon - The icon to use when the button is active.
    * @param {string} inactiveIcon - The icon to use when the button is inactive.
    * @param {string} activeTooltip - The tooltip to show when the button is active.
    * @param {string} inactiveTooltip - The tooltip to show when the button is inactive.
    * 
*/
export default function MediaControlButton({
    id,
    name,

    onClick,
    onChevronClick,

    hasChevron = false,
    loading = false,
    active = false,
    disabled = false,

    activeIcon,
    inactiveIcon,
    activeTooltip,
    inactiveTooltip,
    activeStyle = "icon-active",
    inactiveStyle = "icon-inactive",
    anchorEl
}) {

    const buttonRef = useRef(null);

    /*--------------Tooltip-height---------*/
    const getTooltipOffset = (panelElement) => {
        return ({ reference }) => {
            if (!panelElement) return [0, 10];
            const panelRect = panelElement.getBoundingClientRect();
            const distance = (reference.y - panelRect.y) / 2;
            return [0, distance];
        };
    };

    /*-------------- LOGIC -------------- */
    const PeoplmapTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(() => ({
        zIndex: 10009,
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: '#ffffff',
            color: '#000000',
            fontSize: '0.875rem',
            borderRadius: '0.5rem',
            padding: '0.5rem 0.75rem',
            fontFamily: '"Roboto", sans-serif',
            zIndex: 10009,
            boxShadow: '0 0.5rem 1.375rem rgba(0, 0, 0, 0.18)',
        },
        [`& .${tooltipClasses.arrow}`]: {
            color: '#ffffff',
            zIndex: 10009,
        },
    }));


    /*-------------- RENDERING -------------- */
    return (
        <PeoplmapTooltip arrow placement="top" title={name === 'whiteboard' ? '' : active ? activeTooltip : inactiveTooltip}
            disableHoverListener={name === 'whiteboard'}
            disableFocusListener={name === 'whiteboard'}
            disableTouchListener={name === 'whiteboard'}
            PopperProps={{
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            // CLEAN: Just call the helper here
                            offset: getTooltipOffset(anchorEl),
                        },
                    },
                ],
            }}>
            <button 
                ref={buttonRef}
                id={`tour-btn-${ id || name}`}
                disabled={disabled}
                className={`control-btn ${active ? activeStyle : inactiveStyle
                    }`}
            >
                {loading &&
                    <span className="loader-device-bg" onClick={onClick}>
                        <Loader className="loader-device" />
                    </span>
                }
                <span onClick={onClick} className={'menu-icon'}>
                    {active ? (
                        <span className="material-symbols-outlined" alt={name}>
                            {activeIcon}
                        </span>
                    ) : (
                        <span className="material-symbols-outlined" alt={name}>
                            {inactiveIcon}
                        </span>
                    )}
                    {name == 'whiteboard' && <span className="label-btn">Tableau blanc</span>}

                    {name == 'record' && <span className="label-btn">Démarrer l'enregistrement</span>}
                </span>

                {hasChevron &&
                    <span className="material-symbols-outlined arrow" onClick={(e) => onChevronClick(e.currentTarget)}>
                        keyboard_arrow_up
                    </span>}


            </button>
        </PeoplmapTooltip>
    )
}
